import { InternalContactsList } from './InternalContactsList';

export const InternalContactsListMember = () => <InternalContactsList onSave={async () => null} showSearch readOnly />;
